// import DlvMng from "../views/DlvMng.svelte";
// import DlvMngDtl from "../views/DlvMngDtl.svelte";
import Login from "../views/Login.svelte";
import MemoMng from "../views/MemoMng.svelte";
import MemoMngDtl from "../views/MemoMngDtl.svelte";
// import BcncMng from "../views/BcncMng.svelte";
// import DateMng from "../views/DateMng.svelte";
// import EmplMng from "../views/EmplMng.svelte";
// import ItemMng from "../views/ItemMng.svelte";
// import SiteMng from "../views/SiteMng.svelte";
import WorkMng from "../views/WorkMng.svelte";
import WorkMngDtl from "../views/WorkMngDtl.svelte";

export const mainRoutres = {
    "/login": Login,
    // "/DlvMng": DlvMng,
    // "/DlvMngDtl/:no": DlvMngDtl,
    "/MemoMng": MemoMng,
    "/MemoMngDtl/:no": MemoMngDtl,
    // "/BcncMng": BcncMng,
    // "/DateMng": DateMng,
    // "/EmplMng": EmplMng,
    // "/ItemMng": ItemMng,
    // "/SiteMng": SiteMng,
    "/WorkMng": WorkMng,
    "/WorkMngDtl/:no": WorkMngDtl,
};
